import { render, staticRenderFns } from "./individualCallSplit.vue?vue&type=template&id=aed93228&scoped=true"
import script from "./individualCallSplit.vue?vue&type=script&lang=js"
export * from "./individualCallSplit.vue?vue&type=script&lang=js"
import style0 from "./individualCallSplit.vue?vue&type=style&index=0&id=aed93228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed93228",
  null
  
)

export default component.exports